import { Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpClient } from '@angular/common/http';
declare var device;
import { from, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthGoogleService } from './auth-google/auth-google.service';
import { ENVIRONMENT, Environment } from '@shared/environment';
import { EndPointService } from '../services/endpoint.service';
import { EmailAuthenticationService } from '../services/email-authentication.service';

import moment from 'moment';
import { ChatService } from '../services/chat.service';
import { StorageHelperService } from '../services/storage-helper.service';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
	private readonly env = inject<Environment>(ENVIRONMENT);
	private readonly http = inject(HttpClient);
	private readonly router = inject(Router);
	private readonly authGoogleService = inject(AuthGoogleService);
	private readonly endPointService = inject(EndPointService);
	private readonly emailService = inject(EmailAuthenticationService);
	private readonly snackBar = inject(MatSnackBar);
	private readonly message = inject(ChatService);
	private readonly storageHelper = inject(StorageHelperService);
	
	apiUrl;
	companyName = this.env.company;
	chatSignalr;
	confirmLogin = false;
	ggSync;
	private GOOGLE_ALREADY_LOGGED = 'You already logged in google apis.';

	constructor() {
		this.endPointService.companySource.subscribe((data) => {
			this.apiUrl = data.apiUrl;
			this.chatSignalr = data.chatSignalr;
		});

		this.companyName = this.env.company;
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return from(this.handle(req, next));
	}

	async handle(req: HttpRequest<any>, next: HttpHandler) {
		const authorization = (await this.storageHelper.getItem('token')) || '';
		let companyCode = (await this.storageHelper.getItem('companyCode')) || '';

		// switch to mobile
		// companyCode = 'test';
		let devicesLogin = '';
		// let devicesLogin = 'ios';
		if (typeof device !== 'undefined') {
			devicesLogin = device.platform.toLowerCase().trim();
		}
		const localTime = moment(new Date()).format('MM/DD/YYYY HH:mm:ss');
		const timezoneOffset = moment(new Date()).format('Z');
		const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		let authReq = req.clone({
			url: `${this.apiUrl}${req.url}`,
			headers: req.headers
				.append('tokenCC', companyCode)
				.append('devices', devicesLogin)
				.append('localTime', localTime)
				.append('timezoneOffset', timezoneOffset)
				.append('timeZone', timeZone)
		});
		if (authorization) {
			authReq = req.clone({
				headers: req.headers
					.set('Authorization', authorization)
					.append('tokenCC', companyCode)
					.append('devices', devicesLogin)
					.append('localTime', localTime)
					.append('timezoneOffset', timezoneOffset)
					.append('timeZone', timeZone),
				url: `${this.apiUrl}${req.url}`
			});
		}

		if (req.url.includes('file://') || (req.url.includes('http') && !req.url.includes(this.chatSignalr))) {
			return next.handle(req).toPromise();
		} else if (req.url.includes(this.chatSignalr)) {
			const authRequest = req.clone({
				url: `${req.url}`,
				headers: req.headers
					.set('Authorization', authorization)
					.append('tokenCC', companyCode)
					.append('devices', devicesLogin)
					.append('localTime', localTime)
					.append('timezoneOffset', timezoneOffset)
					.append('timeZone', timeZone)
			});
			return next.handle(authRequest).toPromise();
		} else {
			// send the newly created request
			return next
				.handle(authReq)
				.pipe(
					tap(
						(event) => {
							// if (event instanceof HttpResponse) { }
						},
						(error) => {
							if (error.status === 403) {
								this.snackBar.open(error.error['Message']);
							}
							// Google APIs is PAUSED
							if (error.status === 401) {
								this.message.disconnect();
								sessionStorage.clear();
								sessionStorage.setItem('showSplash', JSON.stringify(false));
								this.router.navigate(['signin']);
							} else if (
								error['error'] &&
								error['error'].Message === "Haven't signed in google apis." &&
								this.confirmLogin === false
							) {
								// this.googleAuthDialog();
							}
						}
					)
				)
				.toPromise();
		}
	}

	private googleAuthDialog() {
		if (!this.ggSync || (this.ggSync.openDialogs && this.ggSync.openDialogs.length == 0)) {
			this.ggSync = this.authGoogleService.openDialog();
			this.ggSync.afterClosed().subscribe((result) => {
				if (result) {
					this.authGoogleService.getGooglePermisson().subscribe(
						(rs) => {
							if (rs !== this.GOOGLE_ALREADY_LOGGED) {
								let url = rs.toString();
								this.authGoogleService.openLinkInBrowser(url, (mess) => {
									if (mess == 'closed') {
										console.log('interceptor next true');
										this.emailService.shouldRefreshEmailProfile(true);
									}
								});
								// } else {
								//    alert(this.GOOGLE_ALREADY_LOGGED);
							}
						},
						(err) => {
							console.error(err);
						}
					);
				}
			});
		}
	}
}
